export default "__VITE_ASSET__BRlykNfa__"